/**
 * Routes that render their own full-page chrome and must not show the app
 * header, footer or floating widgets. The Customer Liability signing page is
 * one: it is a legal document flow reached from an email, so anything that
 * invites the payer to navigate away is a distraction (and a support call).
 */
export const STANDALONE_ROUTE_PREFIXES = ["/payment-agreement"];

export const isStandaloneRoute = (pathname = "") =>
  STANDALONE_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
